import {
  LoadScript,
  GoogleMap,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import vendorIcon from "../images/vendor.svg";
import virtualTour from "../images/vtourfilled.svg";
import emailIcon from "../images/email.svg";
import arcthect from "../images/architecture.svg";
import globalIcon from "../images/globalfilled.svg";
import mobileIcon from "../images/mobile.svg";
import pdfIcon from "../images/pdf2.svg";
import apartmentImage from "../images/sponer.svg";
// import linkicon from '../images/link.png';
// import calenderLogo from '../images/calender.png';
import timeIcon from "../images/time.png";
import deleteIcon from "../images/trash.svg";
import Autocomplete from "react-google-autocomplete";
import { authFetch } from "../utils/authFetch";
import { BASE_URL } from "../utils/config";
import { uploadImagesMultipart } from "../utils/uploadFiles";
import Modal from "../utils/Modal";
import { useAuth } from "../context/AuthContext";
import { useFlow } from "../context/FlowContext";
import {
  useNavigate,
  useSearchParams,
  useParams,
  Link,
} from "react-router-dom";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import { useTranslation } from "react-i18next";
import styles from "./OfferProperty.module.css";
import NewSearchesSwiper from "../components/NewSearchesSwiper";
import { prepareCriteriaForSave, loadCriteriaFromBackend, getDisplayValue, isCriteriaSelected, getIdentifier } from "../utils/criteriaHelpers";

const api_Key =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const createSvgIcon = (path, viewBox = "0 0 24 24") =>
  `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" fill="currentColor">${path}</svg>`;
const starIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" fill="red" viewBox="0 0 24 24" width="20" height="20">
    <path d="M12 2l2.9 6.9L22 9.2l-5 5.1 1.2 7.7L12 18.8l-6.2 3.2L7 14.3l-5-5.1 7.1-0.3L12 2z"/>
  </svg>
`;

const initialFormData = {
  offeringType: "purchase",
  propertyType: "house/villa",
  address: "",
  country: "",
  city: "",
  zipcode: "",
  price: "",
  bedrooms: "",
  units: null,
  index: "",
  squareFootage: "",
  countryId: "",
  propertyTitle: "",
  description: "",
  condition: null,
  location: null,
  residenceType: null,
  floorLevel: null,
  viewType1: null,
  viewType2: null,
  roofStyle: null,
  architectureStyle: null,
  levels: null,
  position: null,
  parking: null,
  facilities: null,
  features: null,
  energySource: null,
  extras: null,
  convenientTaxation: false,
  images: [],
  vendorName: "",
  link1: "",
  link2: "",
  email: "",
  availableDays: "",
  designImages: "",
  website: "",
  phone: "",
  brochure: "",
  brochureFilename: "",
  preferredTime: "",
  public: false,
  vendorNamePublic: false,
  link1Public: false,
  link2Public: false,
  emailPublic: false,
  daysPublic: false,
  designPublic: false,
  websitePublic: false,
  phonePublic: false,
  brochurePublic: false,
  brochureFilename: "",
  designFilename: "",
  timePublic: false,
  designFilename: "",
  designFile: null,
  contactTime: "",
  propertyCriteriaId: null,
  contactTimeVisible: false,
};
const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const OfferProperty = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setFlow } = useFlow();
  const { isAuthenticated, currentUser } = useAuth();
  const [uploadedImages, setUploadedImages] = useState([]);
  const [step, setStep] = useState(1);
  const [maxAllowedStep, setMaxAllowedStep] = useState(1);
  const { id: paramPropertyId } = useParams();
  const [validationErrors, setValidationErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentPropertyId, setCurrentPropertyId] = useState(null);
  const [offers, setOffers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sliderKey, setSliderKey] = useState(Date.now());
  const [activeTab, setActiveTab] = useState(1);
  const [showMainImageModal, setShowMainImageModal] = useState(false);
  const [criteriaGroups, setCriteriaGroups] = useState([]);
  const [loadingCriteria, setLoadingCriteria] = useState(true);
  const [originalCriteria, setOriginalCriteria] = useState(null); // Store identifier-based criteria for language switching

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({
    link1: "",
    link2: "",
    website: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await authFetch(
          `${BASE_URL}/property/latest/offers?limit=30`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch offers");
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const data = await response.json();
          console.log("📊 Fetched offers data:", data);
          console.log("📊 Number of offers:", data?.length || 0);
          // Ensure we always set an array, even if API returns null/undefined
          setOffers(Array.isArray(data) ? data : []);
          setSliderKey(Date.now());
        } else {
          const text = await response.text();
          throw new Error(
            `Server returned a non-JSON response. Check your API route. Response was: "${text.substring(
              0,
              50
            )}..."`
          );
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching offers:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOffers();

    // const intervalId = setInterval(fetchOffers, 60000);

    return () => {
      // Polling disabled to prevent property changes during animation
      // clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    console.log("🔄 Fetching criteria options for language:", i18n.language);
    const langCode = i18n.language.split("-")[0]; // "en-US" → "en"

    const fetchCriteriaOptions = async () => {
      try {
        const response = await authFetch(
          // `${BASE_URL}/property/criteria-options/${
          //   i18n.language == "en-US" ? "en" : i18n.language
          // }`
          `${BASE_URL}/property/criteria-options/${langCode}`
        );

        const data = await response.json();

        if (response.ok) {
          console.log("🔍 API Response for criteria options:", data);
          console.log("🔍 First group structure:", data?.data[0]);
          console.log(
            "🔍 Multiselect flags:",
            data?.data?.map((group) => ({
              groupName: group.groupName,
              isMultiSelect: group.isMultiSelect,
              multiselect: group.multiselect,
            }))
          );

          // Sort criteria groups by sortOrder
          const sortedCriteria = (data?.data || []).sort((a, b) => {
            return (a.sortOrder || 0) - (b.sortOrder || 0);
          });
          setCriteriaGroups(sortedCriteria);
          setFormData((prevFormData) => {
            const newFormData = { ...prevFormData };
            data.data.forEach((group) => {
              if (newFormData[group.groupName] === undefined) {
                // Initialize based on multiselect flag
                const isGroupMultiselect =
                  group.isMultiSelect ||
                  group.multiselect ||
                  ["facilities", "extras", "parking", "energySource"].includes(
                    group.groupName
                  );
                if (isGroupMultiselect) {
                  newFormData[group.groupName] = [];
                  console.log(
                    `🔍 Initializing ${group.groupName} as array (multiselect)`
                  );
                } else {
                  newFormData[group.groupName] = "";
                  console.log(
                    `🔍 Initializing ${group.groupName} as string (single-select)`
                  );
                }
              }
            });
            return newFormData;
          });
        } else {
          console.error("Failed to fetch criteria options:", data);
        }
      } catch (error) {
        console.error("Error fetching criteria options:", error);
      } finally {
        setLoadingCriteria(false);
      }
    };

    console.log(">>>>>>>>>>>>>>>>>>>>> language", i18n.language, step);

    fetchCriteriaOptions();
  }, [i18n.language]); // Don't depend on step - only refetch when language changes

  // Normalize criteria when criteriaGroups load or language changes (for edit mode)
  useEffect(() => {
    if (criteriaGroups.length > 0 && isEditMode && originalCriteria) {
      console.log("🔄 Normalizing offer criteria to current language...");
      console.log("  - Original criteria (identifier keys):", originalCriteria);

      // Convert identifier keys to groupName keys, but KEEP identifier values
      // (identifiers are language-agnostic, display values are for UI only)
      const normalizedCriteria = {};
      Object.entries(originalCriteria).forEach(([key, value]) => {
        // Find the group by identifier
        const group = criteriaGroups.find(g => g.identifier === key);
        if (group) {
          // Keep values as-is (identifiers) - don't convert to display values
          // This allows checkbox comparison to work correctly
          if (typeof value === 'string' && value) {
            // Store as array if group is multi-select, otherwise as string
            if (group.isMultiSelect) {
              normalizedCriteria[group.groupName] = [value];
            } else {
              normalizedCriteria[group.groupName] = value;
            }
          }
          // For arrays (keep identifier values)
          else if (Array.isArray(value)) {
            normalizedCriteria[group.groupName] = value; // Keep identifiers as-is
          }
          // For empty multi-select groups, initialize as empty array
          else if (group.isMultiSelect) {
            normalizedCriteria[group.groupName] = [];
          }
        } else {
          console.warn(`Group not found for identifier: ${key}`);
        }
      });

      console.log("  - Normalized criteria (groupName keys, identifier values):", normalizedCriteria);

      setFormData(prev => ({
        ...prev,
        ...normalizedCriteria
      }));
    }
  }, [criteriaGroups, isEditMode, originalCriteria]); // Run when criteriaGroups loads or changes

  function normalizeValueToKey(value) {
    return value
      .replace(/[^a-zA-Z0-9]+/g, "_") // Replace one or more non-alphanumeric chars with a single underscore
      .replace(/^_|_$/g, "") // Remove leading/trailing underscores
      .toLowerCase();
  }

  // Helper function to prepare offer criteria for saving (using identifiers)
  const prepareOfferCriteriaForSave = () => {
    const criteriaObj = {};

    // Collect all criteria from formData
    console.log("📤 === PREPARING OFFER CRITERIA FOR SAVE ===");
    console.log("📤 Total criteria groups:", criteriaGroups.length);

    criteriaGroups.forEach((group) => {
      const value = formData[group.groupName];
      console.log(`📤 Group "${group.groupName}" (identifier: "${group.identifier}"):`, {
        value: value,
        type: typeof value,
        isArray: Array.isArray(value),
        length: Array.isArray(value) ? value.length : 'N/A'
      });

      if (value !== undefined && value !== null && value !== "") {
        if (Array.isArray(value) && value.length > 0) {
          criteriaObj[group.groupName] = value;
          console.log(`  ✅ Added array with ${value.length} items:`, value);
        } else if (!Array.isArray(value)) {
          criteriaObj[group.groupName] = value;
          console.log(`  ✅ Added single value:`, value);
        }
      }
    });

    console.log("📤 Collected criteria before conversion:", JSON.stringify(criteriaObj, null, 2));
    console.log("📤 CriteriaGroups structure:", criteriaGroups.map(g => ({
      groupName: g.groupName,
      identifier: g.identifier,
      valuesCount: g.values?.length,
      firstValue: g.values?.[0]
    })));

    // Convert to identifiers using helper function
    const criteriaWithIdentifiers = prepareCriteriaForSave(criteriaObj, criteriaGroups);

    console.log("📤 After conversion to identifiers:", JSON.stringify(criteriaWithIdentifiers, null, 2));

    // For offer properties, keep arrays for multi-select groups, single values for single-select
    // The backend will store exactly what we send (arrays or single values)
    const finalCriteria = {};
    Object.entries(criteriaWithIdentifiers).forEach(([key, value]) => {
      console.log(`  🔄 Processing key "${key}":`, value);
      if (Array.isArray(value) && value.length > 0) {
        // Keep array as-is for multi-select groups (e.g., facilities can have multiple values)
        finalCriteria[key] = value;
        console.log(`    ➡️ Kept array with ${value.length} values:`, value);
      } else if (value !== undefined && value !== null && value !== "") {
        finalCriteria[key] = value;
        console.log(`    ➡️ Kept single value: "${value}"`);
      }
    });

    console.log("✅ Final offer criteria (with identifiers):", JSON.stringify(finalCriteria, null, 2));
    console.log("📤 === END PREPARATION ===");
    return finalCriteria;
  };

  useEffect(() => {
    setFlow("offer");

    if (paramPropertyId) {
      ////// EDIT MODE
      setIsEditMode(true);
      setCurrentPropertyId(paramPropertyId);
      localStorage.setItem("propertyId", paramPropertyId);

      const fetchPropertyData = async () => {
        try {
          const response = await authFetch(
            `${BASE_URL}/property/${paramPropertyId}`
          );
          if (!response.ok) {
            console.log("Fetched Property Data:", response.data);
            throw new Error("Failed to fetch property details for editing.");
          }
          const result = await response.json();
          const fetchedProperty = result.data;

          setFormData({
            propertyTitle: fetchedProperty.propertyTitle || "",
            description: fetchedProperty.description || "",
            offeringType: fetchedProperty.offeringType || "purchase",
            propertyType: fetchedProperty.propertyType || "house/villa",
            address: fetchedProperty.PropertyAddresses?.[0]?.fullAddress || "",
            country: fetchedProperty.PropertyAddresses?.[0]?.countryName || "",
            countryId: fetchedProperty.PropertyAddresses?.[0]?.id || null,
            city: fetchedProperty.PropertyAddresses?.[0]?.city || "",
            zipcode: fetchedProperty.PropertyAddresses?.[0]?.zipCode || "",
            price:
              fetchedProperty.price !== undefined
                ? String(fetchedProperty.price)
                : "",
            bedrooms:
              fetchedProperty.bedrooms !== undefined
                ? String(fetchedProperty.bedrooms)
                : "",
            units:
              fetchedProperty.units !== undefined
                ? String(fetchedProperty.units)
                : "",
            index:
              fetchedProperty.index !== undefined
                ? String(fetchedProperty.index)
                : "",
            squareFootage:
              fetchedProperty.squareMeters !== undefined
                ? String(fetchedProperty.squareMeters)
                : "",
            propertyCriteriaId: fetchedProperty.PropertyCriterium?.id || null,
            ...(fetchedProperty.PropertyCriterium?.criteria || {}),
            images: fetchedProperty.PropertyShowcase?.images || [],
            vendorName: fetchedProperty.PropertyShowcase?.vendorName || "",
            vendorNamePublic:
              fetchedProperty.PropertyShowcase?.vendorNameVisible ?? false,
            link1: fetchedProperty.PropertyShowcase?.externalLink || "",
            link1Public:
              fetchedProperty.PropertyShowcase?.externalLinkVisible ?? false,
            link2: fetchedProperty.PropertyShowcase?.virtualTour || "",
            link2Public:
              fetchedProperty.PropertyShowcase?.virtualTourVisible ?? false,
            email: fetchedProperty.PropertyShowcase?.email || "",
            emailPublic:
              fetchedProperty.PropertyShowcase?.emailVisible ?? false,
            contactTime: fetchedProperty.PropertyShowcase?.contactTime || "",
            contactTimeVisible:
              fetchedProperty.PropertyShowcase?.contactTimeVisible ?? false,
            designImages:
              fetchedProperty.PropertyShowcase?.architecturePdf?.[0] || "",
            designPublic:
              fetchedProperty.PropertyShowcase?.architecturePdfVisible ?? false,
            designFilename: fetchedProperty.PropertyShowcase
              ?.architecturePdf?.[0]
              ? fetchedProperty.PropertyShowcase.architecturePdf[0]
                  .split("/")
                  .pop()
              : "",
            website: fetchedProperty.PropertyShowcase?.websiteUrl || "",
            websitePublic:
              fetchedProperty.PropertyShowcase?.websiteUrlVisible ?? false,
            phone: fetchedProperty.PropertyShowcase?.phone || "",
            phonePublic:
              fetchedProperty.PropertyShowcase?.phoneVisible ?? false,
            brochure: fetchedProperty.PropertyShowcase?.brochure?.[0] || "",
            brochurePublic:
              fetchedProperty.PropertyShowcase?.brochureVisible ?? false,
            brochureFilename: fetchedProperty.PropertyShowcase?.brochure?.[0]
              ? fetchedProperty.PropertyShowcase.brochure[0].split("/").pop()
              : "",
            location: null,
            floorPosition: null,
            viewType: null,
            natureViewType: null,
            roofType: null,
            styleType: null,
            levelType: null,
            positionType: null,
            parkingType: null,
            features: null,
            energy: null,
            preferredTime: null,
            public: false,
            designFile: null,
            brochureFile: null,
          });

          // Store original criteria with identifier keys for language switching
          setOriginalCriteria(fetchedProperty.PropertyCriterium?.criteria || {});

          const loadedUploadedImages = [];
          if (fetchedProperty.PropertyShowcase?.mainImage) {
            loadedUploadedImages.push({
              id: Math.random().toString(36).slice(2, 11),
              url: fetchedProperty.PropertyShowcase.mainImage,
              isMain: true,
              file: null,
            });
          }
          if (fetchedProperty.PropertyShowcase?.images) {
            fetchedProperty.PropertyShowcase.images.forEach((imgUrl) => {
              loadedUploadedImages.push({
                id: Math.random().toString(36).slice(2, 11),
                url: imgUrl,
                isMain: false,
                file: null,
              });
            });
          }
          setUploadedImages(loadedUploadedImages);
        } catch (error) {
          console.error("Error fetching property data for edit:", error);
          toast.error(
            "Failed to load property data for editing. Redirecting to MyProperties."
          );
          navigate("/MyProperties");
        }
      };
      fetchPropertyData();
    } else {
      ///// CREATE MODE
      setIsEditMode(false);
      setCurrentPropertyId(null);
      // Pre-populate with user details if available
      const initialData = { ...initialFormData };
      
      // Check URL parameter for rental type
      const typeParam = searchParams.get("type");
      if (typeParam === "rental" || typeParam === "rent") {
        initialData.offeringType = "rental";
      } else {
        // Default to purchase (sale)
        initialData.offeringType = "purchase";
      }
      
      if (isAuthenticated && currentUser) {
        // Pre-populate vendor name
        if (currentUser.name || currentUser.surname) {
          initialData.vendorName = `${currentUser.name || ""} ${currentUser.surname || ""}`.trim();
          // Auto-check visibility checkbox if data is auto-filled
          if (initialData.vendorName) {
            initialData.vendorNamePublic = true;
          }
        }
        // Pre-populate email
        if (currentUser.email) {
          initialData.email = currentUser.email;
          // Auto-check visibility checkbox if data is auto-filled
          if (initialData.email) {
            initialData.emailPublic = true;
          }
        }
        // Pre-populate phone
        if (currentUser.mobile) {
          initialData.phone = currentUser.mobile;
          // Auto-check visibility checkbox if data is auto-filled
          if (initialData.phone) {
            initialData.phonePublic = true;
          }
        }
      }
      setFormData(initialData);
      setUploadedImages([]);
    }
  }, [paramPropertyId, navigate, setFlow, isAuthenticated, currentUser]);

  const emailRegex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  const urlRegex = new RegExp(
    "^(https?:\\/\\/)?" +
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
      "((\\d{1,3}\\.){3}\\d{1,3}))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );

  const phoneRegex = new RegExp(/^\+?(\d[\d\-\(\)\s]{6,}\d)$/);
  const validateUrl = (name, value) => {
    if (!value || value.trim() === "") {
      // Allow empty string if the field is optional
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      return true;
    }

    // Remove http:// and https:// if present, then add .com if not present
    let processedValue = value.trim();
    
    // Remove protocol (check https:// first since it contains http://)
    if (processedValue.toLowerCase().startsWith("https://")) {
      processedValue = processedValue.substring(8);
    } else if (processedValue.toLowerCase().startsWith("http://")) {
      processedValue = processedValue.substring(7);
    }
    
    // Remove www. if present
    if (processedValue.toLowerCase().startsWith("www.")) {
      processedValue = processedValue.substring(4);
    }

    // Add .com if not present and doesn't already have a TLD
    if (processedValue && !processedValue.includes(".")) {
      processedValue = processedValue + ".com";
    }

    // Update the form data with processed value
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: processedValue,
    }));

    // Validate only the domain part (strip path/query before checking)
    const domainPart = processedValue.split("/")[0].split("?")[0];
    const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    if (!domainRegex.test(domainPart)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Please enter a valid URL (e.g., example.com).`,
      }));
      return false;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear error if valid
      }));
      return true;
    }
  };

  const validateEmail = (name, value) => {
    if (value && !emailRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address (e.g., user@example.com)",
      }));
      return false;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
      return true;
    }
  };

  const displayStringToKeyMap = {
    "House/Villa": "house/villa",
    Apartment: "apartment",
    Multifamily: "multifamily",
    Plot: "plot",
  };

  const validatePhone = (name, value) => {
    if (value && !phoneRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid phone number (e.g., +41791234567)",
      }));
      return false;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear error if valid
      }));
      return true;
    }
  };

  const formatWithApostrophe = (value) => {
    if (!value && value !== 0) return '';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/'/g, '')) : value;
    if (isNaN(numValue)) return value;
    const digitsOnly = numValue.toString().replace(/[^\d]/g, '');
    return digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === "link1" || name === "link2" || name === "website") {
      validateUrl(name, value);
    }

    if (name === "email") {
      validateEmail(name, value);
    }
    if (name === "phone") {
      validatePhone(name, value);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let finalValue = value;

    // Apply formatting for specific fields (price, squareFootage)
    if (name === "price" || name === "squareFootage" || name === "units") {
      finalValue = formatWithApostrophe(value);
    }

    // Allow free typing for phone - just clean special chars except + and digits
    if (name === "phone") {
      // Remove characters except digits, +, spaces, hyphens, parentheses
      finalValue = value.replace(/[^\d+\-\(\)\s]/g, "");
    }

    setFormData((prevFormData) => {
      const newState = {
        ...prevFormData,
        [name]: finalValue,
      };

      let associatedCheckboxName = "";

      if (
        name === "vendorName" ||
        name === "link1" ||
        name === "link2" ||
        name === "email" ||
        name === "website" ||
        name === "phone"
      ) {
        associatedCheckboxName = `${name}Public`;
      } else if (name === "contactTime") {
        associatedCheckboxName = "contactTimeVisible";
      }

      if (
        associatedCheckboxName &&
        typeof prevFormData[associatedCheckboxName] === "boolean"
      ) {
        newState[associatedCheckboxName] = finalValue !== "" ? true : false;
      }

      return newState;
    });
  };

  const handleRadioChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleRadioChange2 = (groupName, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [groupName]: value,
    }));
  };

  const handleCheckboxChange2 = (groupName, value) => {
    setFormData((prevFormData) => {
      const currentValues = prevFormData[groupName] || [];
      const isSelected = currentValues.includes(value);

      return {
        ...prevFormData,
        [groupName]: isSelected
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value],
      };
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  const nextStep = async () => {
    console.log("✅ Next button clicked");
    console.log("🧾 Raw Form Data:", formData);

    if (step === 2) {
      // Count total individual criteria selections across all groups
      let totalSelected = 0;
      criteriaGroups.forEach((group) => {
        const value = formData[group.groupName];
        if (Array.isArray(value)) {
          totalSelected += value.length;
        } else if (typeof value === 'string' && value.trim() !== "") {
          totalSelected += 1;
        }
      });

      if (totalSelected < 3) {
        toast.info(t("minimum_criteria_required"));
        return;
      }

      await sendCriteria();
    }
    setStep((prev) => {
      const newStep = prev + 1;
      setMaxAllowedStep((prevMax) => Math.max(prevMax, newStep));
      return newStep;
    });
    setActiveTab((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
    setActiveTab((prev) => prev - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // Validate Step 1 (I am offering)
    if (!formData.propertyType) {
      toast.info(t("missing_propertyType_toast"));
      setStep(1);
      setActiveTab(1);
      return;
    }
    if (!formData.offeringType) {
      toast.info(t("missing_offeringType_toast"));
      setStep(1);
      setActiveTab(1);
      return;
    }
    if (!formData.propertyTitle) {
      toast.info(t("missing_propertyTitle_toast"));
      setStep(1);
      setActiveTab(1);
      return;
    }
    if (!formData.address) {
      toast.info(t("missing_address_toast"));
      setStep(1);
      setActiveTab(1);
      return;
    }
    if (!formData.price) {
      toast.info(t("missing_price_toast"));
      setStep(1);
      setActiveTab(1);
      return;
    }
    if (formData.propertyType === "multifamily") {
      if (!formData.units) {
        toast.info(t("missing_units_toast"));
        setStep(1);
        setActiveTab(1);
        return;
      }
    } else if (formData.propertyType === "plot") {
      if (formData.index === '' || formData.index === null || formData.index === undefined) {
        toast.info(t("missing_index_toast"));
        setStep(1);
        setActiveTab(1);
        return;
      }
    } else {
      // Apartment or House/Villa
      if (!formData.bedrooms) {
        toast.info(t("missing_bedrooms_toast"));
        setStep(1);
        setActiveTab(1);
        return;
      }
    }
    if (!formData.squareFootage) {
      toast.info(t("missing_squareFootage_toast"));
      setStep(1);
      setActiveTab(1);
      return;
    }

    // Validate Step 2 (Property criteria - minimum 3 selections)
    let totalSelected = 0;
    criteriaGroups.forEach((group) => {
      const value = formData[group.groupName];
      if (Array.isArray(value)) {
        totalSelected += value.length;
      } else if (typeof value === 'string' && value.trim() !== "") {
        totalSelected += 1;
      }
    });

    if (totalSelected < 3) {
      toast.info(t("minimum_criteria_required"));
      setStep(2);
      setActiveTab(2);
      return;
    }

    // Validate Step 3 (Showcase)
    if (!formData.vendorName) {
      newErrors.vendorName = true;
    }
    if (!formData.email) {
      newErrors.email = true;
    }
    if (!formData.phone) {
      newErrors.phone = true;
    }

    if (formData.link1 && !validateUrl("link1", formData.link1)) {
      newErrors.link1 = true;
    }
    if (formData.link2 && !validateUrl("link2", formData.link2)) {
      newErrors.link2 = true;
    }
    if (formData.website && !validateUrl("website", formData.website)) {
      newErrors.website = true;
    }
    if (formData.email && !validateEmail("email", formData.email)) {
      newErrors.email = true;
    }
    if (formData.phone && !validatePhone("phone", formData.phone)) {
      newErrors.phone = true;
    }

    setValidationErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      if (newErrors.vendorName) toast.error(t("vendorNameRequired"));
      else if (newErrors.email) toast.error(t("emailRequired"));
      else if (newErrors.phone) toast.error(t("phoneRequired"));
      else if (newErrors.link2 || newErrors.website)
        toast.error(t("invalidFormats"));

      console.log("Form has validation errors.");
      return;
    }

    if (uploadedImages.length === 0) {
      toast.error(t("imageRequired"));
      return;
    }

    const finalPropertyId =
      currentPropertyId || localStorage.getItem("propertyId"); // Fallback for create flow

    if (!finalPropertyId) {
      toast.error(t("propertyIdMissing"));
      return;
    }

    let payload;
    let method;
    let url;

    const mainImageObj = uploadedImages.find((img) => img.isMain);
    const mainImage = mainImageObj ? mainImageObj.url : "";
    const otherImages = uploadedImages
      .filter((img) => !img.isMain)
      .map((img) => img.url);

    if (isEditMode) {
      console.log("country id ", formData.countryId);
      //// PAYLOAD FOR EDIT MODE (PUT /api/property/{id})
      payload = {
        offeringType: formData.offeringType,
        propertyType: formData.propertyType,
        price: Number(removeApostrophes(formData.price)) || 0,
        bedrooms: Number(removeApostrophes(formData.bedrooms)) || 0,
        units: Number(removeApostrophes(formData.units)) || 0,
        index: formData.index ? Number(formData.index) : null,
        squareMeters: Number(removeApostrophes(formData.squareFootage)) || 0,
        listType: "offer",
        propertyTitle: formData.propertyTitle,
        description: formData.description,

        // addresses: [
        //   {
        //     countryId: "",
        //     // countryName: formData.country,
        //     countryISO: "",
        //     city: formData.city,
        //     zipCode: formData.zipcode,
        //     fullAddress: formData.address
        //   }
        // ],
        PropertyAddresses: [
          {
            id: formData.countryId,
            countryISO: "",
            city: formData.city,
            zipCode: formData.zipcode,
            fullAddress: formData.address,
          },
        ],
        PropertyCriteria: {
          id: formData.propertyCriteriaId,
          criteria: prepareOfferCriteriaForSave(),
        },
        PropertyShowcases: {
          mainImage: uploadedImages.find((img) => img.isMain)?.url || "",
          images: uploadedImages
            .filter((img) => !img.isMain)
            .map((img) => img.url),
          vendorName: formData.vendorName,
          vendorNameVisible: formData.vendorNamePublic ?? false,
          externalLink: formData.link1 || "",
          externalLinkVisible: formData.link1Public ?? false,
          virtualTour: formData.link2 || "",
          virtualTourVisible: formData.link2Public ?? false,
          email: formData.email,
          emailVisible: formData.emailPublic ?? false,
          contactTime: formData.contactTime || "",
          contactTimeVisible: formData.contactTimeVisible ?? false,
          architecturePdf: formData.designImages ? [formData.designImages] : [],
          architecturePdfVisible: formData.designPublic ?? false,
          websiteUrl: formData.website || "",
          websiteUrlVisible: formData.websitePublic ?? false,
          phone: normalizePhoneNumber(formData.phone),
          phoneVisible: formData.phonePublic ?? false,
          brochure: formData.brochure ? [formData.brochure] : [],
          brochureVisible: formData.brochurePublic ?? false,
        },
      };
      console.log("Payload: ", payload);
      method = "PUT";
      url = `${BASE_URL}/property/${finalPropertyId}`;
    } else {
      payload = {
        propertyId: finalPropertyId,
        mainImage: mainImage,
        userId: isAuthenticated && currentUser ? currentUser.id : null,
        images: otherImages,
        vendorName: formData.vendorName,
        vendorNameVisible: formData.vendorNamePublic ?? false,
        externalLink: formData.link1 || "",
        externalLinkVisible: formData.link1Public ?? false,
        virtualTour: formData.link2 || "",
        virtualTourVisible: formData.link2Public ?? false,
        email: formData.email,
        emailVisible: formData.emailPublic ?? false,
        contactTime: formData.contactTime || "",
        contactTimeVisible: formData.contactTimeVisible ?? false,
        architecturePdf: formData.designImages ? [formData.designImages] : [],
        architecturePdfVisible: formData.designPublic ?? false,
        websiteUrl: formData.website || "",
        websiteUrlVisible: formData.websitePublic ?? false,
        phone: normalizePhoneNumber(formData.phone),
        phoneVisible: formData.phonePublic ?? false,
        brochure: formData.brochure ? [formData.brochure] : [],
        brochureVisible: formData.brochurePublic ?? false,
        criteria: prepareOfferCriteriaForSave(),
      };
      console.log("Final payload for submission:", payload);
      console.log(`Submitting with method: ${method} to URL: ${url}`);
      method = "POST";
      url = `${BASE_URL}/property/showcase`;
    }

    console.log("Final payload for submission:", payload);
    console.log(`Submitting with method: ${method} to URL: ${url}`);

    try {
      const response = await authFetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Submission failed");
      }

      // For create mode, save PropertyCriteria separately via PUT to /property/{id}
      if (!isEditMode) {
        try {
          const criteriaPayload = {
            PropertyCriteria: {
              criteria: prepareOfferCriteriaForSave(),
            },
          };

          console.log("📤 Saving PropertyCriteria separately:", criteriaPayload);

          const criteriaResponse = await authFetch(
            `${BASE_URL}/property/${finalPropertyId}`,
            {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(criteriaPayload),
            }
          );

          if (criteriaResponse.ok) {
            console.log("✅ PropertyCriteria saved successfully");
          } else {
            console.warn("⚠️ PropertyCriteria save failed, but showcase was created");
          }
        } catch (criteriaError) {
          console.warn("⚠️ Error saving PropertyCriteria:", criteriaError);
        }
      }

      // Trigger matching recalculation after successful property save/update
      try {
        const matchingResponse = await authFetch(
          `${BASE_URL}/property/matching/recalculate`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              propertyId: finalPropertyId,
            }),
          }
        );
        if (matchingResponse.ok) {
          console.log("✅ Matching algorithm triggered successfully");
        } else {
          console.warn("⚠️ Matching recalculation request failed, but property was saved");
        }
      } catch (matchingError) {
        // Don't fail the whole operation if matching trigger fails
        console.warn("⚠️ Error triggering matching recalculation:", matchingError);
      }

      toast.success(
        `Property ${isEditMode ? "updated" : "uploaded"} successfully!`,
        { autoClose: 3000 }
      );

      if (isAuthenticated && currentUser && currentUser.userType === "offer") {
        console.log(
          "User is logged in as an Offer user and correctly matching flow. Redirecting to MyProperties."
        );
        localStorage.removeItem("propertyId");
        navigate("/MyProperties");
      } else {
        console.log(
          "User not logged in OR logged in as wrong userType. Redirecting to login/register for Offer flow."
        );
        const params = new URLSearchParams();
        if (formData.vendorName) params.append("name", formData.vendorName);
        if (formData.phone) params.append("mobile", formData.phone);
        if (formData.email) params.append("email", formData.email);
        params.append("flowType", "offer");
        navigate(`/auth/login?${params.toString()}`);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong during upload: " + err.message);
    }
  };

  const removeApostrophes = (value) => {
    return value.replace(/'/g, "");
  };

  const normalizePhoneNumber = (phone) => {
    if (!phone) return phone;
    // Remove all spaces, hyphens, parentheses
    let cleaned = phone.replace(/[\s\-\(\)]/g, "");
    // Add + at the beginning if not present and has digits
    if (cleaned && !cleaned.startsWith("+")) {
      cleaned = "+" + cleaned;
    }
    return cleaned;
  };

  const buildPropertyPayload = () => {
    return {
      offeringType: formData.offeringType,
      propertyType: formData.propertyType,
      price: Number(removeApostrophes(formData.price)) || 0,
      bedrooms: Number(formData.bedrooms) || 0,
      squareMeters: Number(removeApostrophes(formData.squareFootage)) || 0,
      listType: "offer",
      units: formData.units,
      index: formData.index ? Number(formData.index) : null,
      propertyTitle: formData.propertyTitle,
      description: formData.description,
      addresses: [
        {
          countryName: formData.country,
          countryISO: "",
          city: formData.city,
          zipCode: formData.zipcode,
          fullAddress: formData.address,
        },
      ],
    };
  };

  const skipToNext = () => {
    setStep((prev) => prev + 1);
    setActiveTab((prev) => prev + 1);
  };

  const handleNextStep = async () => {
    const errors = {};

    if (!formData.propertyType) {
      errors.propertyType = true;
    }
    if (!formData.offeringType) {
      errors.offeringType = true;
    }
    if (!formData.propertyTitle) {
      errors.propertyTitle = true;
    }
    if (!formData.address) {
      errors.address = true;
    }
    if (!formData.price) {
      errors.price = true;
    }
    if (formData.propertyType === "multifamily") {
      if (!formData.units) {
        errors.units = true;
      }
    } else if (formData.propertyType === "plot") {
      if (formData.index === '' || formData.index === null || formData.index === undefined) {
        errors.index = true;
      }
    } else {
      if (!formData.bedrooms) {
        errors.bedrooms = true;
      }
    }
    if (!formData.squareFootage) {
      errors.squareFootage = true;
    }

    setValidationErrors(errors);
    console.log("Validation Errors:", errors);

    if (Object.keys(errors).length > 0) {
      const firstError = Object.keys(errors)[0];
      if (firstError === "propertyType")
        toast.info(t("missing_propertyType_toast"));
      else if (firstError === "offeringType")
        toast.info(t("missing_offeringType_toast"));
      else if (firstError === "propertyTitle")
        toast.info(t("missing_propertyTitle_toast"));
      else if (firstError === "address") toast.info(t("missing_address_toast"));
      else if (firstError === "price") toast.info(t("missing_price_toast"));
      else if (firstError === "bedrooms")
        toast.info(t("missing_bedrooms_toast"));
      else if (firstError === "units") toast.info(t("missing_units_toast"));
      else if (firstError === "index") toast.info(t("missing_index_toast"));
      else if (firstError === "squareFootage")
        toast.info(t("missing_squareFootage_toast"));
      return;
    }

    // All fields are present, continue with the next step
    if (!isEditMode) {
      try {
        const response = await authFetch(`${BASE_URL}/property/create`, {
          method: "POST",
          body: JSON.stringify(buildPropertyPayload()),
        });

        const result = await response.json();
        console.log("result:", result);

        if (response.ok) {
          const propertyId = result.data.id;
          localStorage.setItem("propertyId", propertyId);
          setCurrentPropertyId(propertyId);
          console.log("💾 Saved propertyId to localStorage:", propertyId);
          
          // Trigger matching recalculation after property creation
          try {
            const matchingResponse = await authFetch(
              `${BASE_URL}/property/matching/recalculate`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  propertyId: propertyId,
                }),
              }
            );
            if (matchingResponse.ok) {
              console.log("✅ Matching algorithm triggered successfully after property creation");
            } else {
              console.warn("⚠️ Matching recalculation request failed, but property was created");
            }
          } catch (matchingError) {
            // Don't fail the whole operation if matching trigger fails
            console.warn("⚠️ Error triggering matching recalculation:", matchingError);
          }
        } else {
          console.error("❌ API error:", result.message);
          toast.error("Failed to create property: " + result.message);
          return;
        }
      } catch (error) {
        console.error("❌ Error:", error);
        toast.error("Error during property creation: " + error.message);
        return;
      }
    } else {
      console.log("In edit mode, skipping initial property creation API call.");
    }

    nextStep();
  };

  async function sendCriteria() {
    console.log("📤 sendCriteria called!");
    if (!isEditMode) {
      // Save criteria using identifiers to localStorage for registration payload
      const criteriaData = prepareOfferCriteriaForSave();
      localStorage.setItem("propertyCriteria", JSON.stringify(criteriaData));
      console.log("✅ Criteria saved to localStorage:", criteriaData);
    } else {
      console.log(
        "In edit mode, skipping criteria submission API call. Changes held in local state."
      );
    }
  }

  useEffect(() => {
    return () => {};
  }, [uploadedImages]);

  const onDrop = useCallback(
    async (acceptedFiles, fileRejections) => {
      console.log("Files dropped - Accepted:", acceptedFiles);
      console.log("Files dropped - Rejected:", fileRejections);

      if (fileRejections.length > 0) {
        const errorMessages = fileRejections
          .map((rejection) => {
            const fileName = rejection.file.name;
            const errors = rejection.errors
              .map((err) => {
                if (err.code === "file-invalid-type")
                  return t("has_invalid_type"); // New key: has_invalid_type
                if (err.code === "too-many-files")
                  return t("exceeds_max_files"); // New key: exceeds_max_files
                return err.message;
              })
              .join("; ");
            return `${fileName}: ${errors}`;
          })
          .join("\n");
        toast.error(`${t("Upload_Error")}:\n${errorMessages}`); // New key: Upload_Error
      }

      // Compress all images in parallel for better performance
      const compressionPromises = acceptedFiles.map(async (file) => {
        const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

        if (fileSizeInMB > 1) {
          console.log(
            `Image ${file.name} is ${fileSizeInMB.toFixed(2)}MB. Compressing...`
          );
          toast.info(
            t("image_larger_than_1MB", {
              fileName: file.name,
              fileSize: fileSizeInMB.toFixed(2),
            })
          );

          try {
            const options = {
              maxSizeMB: 1,
              maxWidthOrHeight: 1920,
              useWebWorker: true,
              fileType: file.type,
            };
            const compressedFile = await imageCompression(file, options);
            console.log(
              `Image ${file.name} compressed from ${fileSizeInMB.toFixed(
                2
              )}MB to ${(compressedFile.size / (1024 * 1024)).toFixed(2)}MB`
            );
            toast.success(
              t("image_compressed_success", {
                originalSize: fileSizeInMB.toFixed(2),
                compressedSize: (compressedFile.size / (1024 * 1024)).toFixed(
                  2
                ),
              })
            );
            return compressedFile;
          } catch (error) {
            console.error(`Error compressing image ${file.name}:`, error);
            toast.error(t("Failed_To_Compress_Image", { fileName: file.name }));
            return null;
          }
        } else {
          return file;
        }
      });

      // Wait for all compressions to complete
      const compressedResults = await Promise.all(compressionPromises);

      // Filter out any failed compressions (null values)
      const filesToProcessForUpload = compressedResults.filter(file => file !== null);

      const finalFilesToSend = filesToProcessForUpload.slice(
        0,
        6 - uploadedImages.length
      );

      if (finalFilesToSend.length === 0) {
        console.log(t("No_New_Valid_Images")); // New key: No_New_Valid_Images
        return;
      }

      try {
        const uploadResult = await uploadImagesMultipart(finalFilesToSend);

        setUploadedImages((prev) => {
          const newImages = uploadResult.uploadedFiles.map((f) => ({
            ...f,
            id: Math.random().toString(36).slice(2, 11),
            isMain: false,
          }));

          if (prev.length === 0 && newImages.length > 0) {
            newImages[0].isMain = true;
          }

          return [...prev, ...newImages];
        });
        toast.success(t("Images_Uploaded_Successfully")); // New key: Images_Uploaded_Successfully
      } catch (err) {
        console.error("Image upload failed:", err);
        toast.error(t("Image_Upload_Failed") + ": " + err.message); // New key: Image_Upload_Failed
      }
    },
    [uploadedImages.length, t]
  );
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    fileRejections: dropzoneFileRejections,
  } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    maxFiles: 6,
  });

  const selectMainImage = useCallback((selectedImageId) => {
    setUploadedImages((prevImages) =>
      prevImages.map((img) => ({
        ...img,
        isMain: img.id === selectedImageId,
      }))
    );
    setShowMainImageModal(false);
  }, []);

  const removeImage = useCallback((idToRemove) => {
    setUploadedImages((prev) => {
      const removedWasMain = prev.find((img) => img.id === idToRemove)?.isMain;
      const updated = prev.filter((img) => img.id !== idToRemove);

      if (removedWasMain && updated.length > 0) {
        updated[0].isMain = true;
      } else if (
        !removedWasMain &&
        updated.length > 0 &&
        !updated.some((img) => img.isMain)
      ) {
        updated[0].isMain = true;
      }
      return updated;
    });
  }, []);

  const handleBrochureUpload = async (e) => {
    const file = e.target.files[0];
    console.log("Brochure file selected:", file);

    if (!file) {
      console.log(t("No_Brochure_File_Selected")); // New key: No_Brochure_File_Selected
      setFormData((prev) => ({
        ...prev,
        brochure: "",
        brochureFilename: "",
        brochureFile: null,
        brochurePublic: false,
      }));
      return;
    }
    if (file.type !== "application/pdf") {
      toast.error(t("Please_Upload_PDF_File")); // New key: Please_Upload_PDF_File
      setFormData((prev) => ({
        ...prev,
        brochure: "",
        brochureFilename: "",
        brochureFile: null,
        brochurePublic: false,
      }));
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error(t("PDF_Size_Under_10MB"));
      setFormData((prev) => ({
        ...prev,
        brochure: "",
        brochureFilename: "",
        brochureFile: null,
        brochurePublic: false,
      }));
      return;
    }

    try {
      const uploadResult = await uploadImagesMultipart([file]);
      if (uploadResult.uploadedFiles && uploadResult.uploadedFiles.length > 0) {
        setFormData((prev) => ({
          ...prev,
          brochure: uploadResult.uploadedFiles[0].url,
          brochureFilename: uploadResult.uploadedFiles[0].fileName,
          brochureFile: file,
          brochurePublic: true,
        }));
        console.log(
          t("Brochure_Uploaded_Success", {
            url: uploadResult.uploadedFiles[0].url,
            fileName: uploadResult.uploadedFiles[0].fileName,
          })
        ); // New key: Brochure_Uploaded_Success
        toast.success(t("Brochure_Uploaded_Successfully_Toast")); // New key: Brochure_Uploaded_Successfully_Toast
      } else {
        throw new Error(t("No_File_URL_Returned")); // New key: No_File_URL_Returned
      }
    } catch (err) {
      console.error("Brochure upload failed:", err);
      toast.error(t("Brochure_Upload_Failed") + ": " + err.message); // New key: Brochure_Upload_Failed
      setFormData((prev) => ({
        ...prev,
        brochure: "",
        brochureFilename: "",
        brochureFile: null,
        brochurePublic: false,
      }));
    }
  };

  const handleDesignUpload = async (e) => {
    const file = e.target.files[0];
    console.log("Design file selected:", file);

    if (!file) {
      console.log(t("No_Design_File_Selected")); // New key: No_Design_File_Selected
      setFormData((prev) => ({
        ...prev,
        designImages: "",
        designFilename: "",
        designFile: null,
        designPublic: false,
      }));
      return;
    }

    if (file.type !== "application/pdf") {
      toast.error(t("Please_Upload_PDF_File"));
      setFormData((prev) => ({
        ...prev,
        designImages: "",
        designFilename: "",
        designFile: null,
        designPublic: false,
      }));
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      toast.error(t("Design_PDF_Size_Under_10MB"));
      setFormData((prev) => ({
        ...prev,
        designImages: "",
        designFilename: "",
        designFile: null,
        designPublic: false,
      }));
      return;
    }

    try {
      const uploadResult = await uploadImagesMultipart([file]);
      if (uploadResult.uploadedFiles && uploadResult.uploadedFiles.length > 0) {
        setFormData((prev) => ({
          ...prev,
          designImages: uploadResult.uploadedFiles[0].url,
          designFilename: uploadResult.uploadedFiles[0].fileName,
          designFile: file,
          designPublic: true,
        }));
        console.log(
          t("Design_PDF_Uploaded_Success", {
            url: uploadResult.uploadedFiles[0].url,
            fileName: uploadResult.uploadedFiles[0].fileName,
          })
        ); // New key: Design_PDF_Uploaded_Success
        toast.success(t("Design_PDF_Uploaded_Successfully_Toast")); // New key: Design_PDF_Uploaded_Successfully_Toast
      } else {
        throw new Error(t("No_File_URL_Returned")); // Re-used key
      }
    } catch (err) {
      console.error("Design PDF upload failed:", err);
      toast.error(t("Design_PDF_Upload_Failed") + ": " + err.message); // New key: Design_PDF_Upload_Failed
      setFormData((prev) => ({
        ...prev,
        designImages: "",
        designFilename: "",
        designFile: null,
        designPublic: false,
      }));
    }
  };

  const fileInputRef = useRef();

  const handleClickUpload = () => {
    fileInputRef.current?.click();
  };
  const bedroomOptions = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6+", value: "6" }, // '6+' for display, '6' for the actual value
  ];


  // Filter out properties where deletedAt is not null before displaying
  const validOffers = offers.filter(item => !item.deletedAt || item.deletedAt === null);

  // Debug: Log the visibility condition
  console.log("🔍 Left Panel Visibility Check:", {
    isLoading,
    hasError: !!error,
    offersCount: offers.length,
    shouldShow: !isLoading && !error && offers.length > 0,
  });

  return (
    <div className={styles.container}>
      {/* Only show left panel if there's data */}

      <div className={styles.leftPanel}>
        {!isLoading && !error && offers.length > 0 && (
          <div className={styles.newSearchesHeader}>
            <h2 className={styles.newSearchesTitle}>{t("new_offers")}</h2>
          </div>
        )}

        {validOffers.length > 0 && (
          <div className={styles.propertyList}>
            <NewSearchesSwiper items={validOffers} className={styles.mySwiper} />
          </div>
        )}
      </div>

      {/* Right Side - Form */}
      <div className={styles.rightPanel}>
        {/* Navigation Tabs */}
        <div className={styles.tabContainer}>
          <button
            className={`${styles.tabButton} ${
              activeTab === 1 ? styles.activeTab : ""
            }`}
            style={{
              borderTopLeftRadius: "15px",
              opacity: (isEditMode || maxAllowedStep >= 1) ? 1 : 0.6,
              cursor: (isEditMode || maxAllowedStep >= 1) ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (isEditMode || maxAllowedStep >= 1) {
                setStep(1);
                setActiveTab(1);
              }
            }}
            disabled={!isEditMode && maxAllowedStep < 1}
          >
            {t("title-offer")}
          </button>
          <button
            className={`${styles.tabButton} ${
              activeTab === 2 ? styles.activeTab : ""
            }`}
            style={{
              opacity: (isEditMode || maxAllowedStep >= 2) ? 1 : 0.6,
              cursor: (isEditMode || maxAllowedStep >= 2) ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (isEditMode || maxAllowedStep >= 2) {
                setStep(2);
                setActiveTab(2);
              }
            }}
            disabled={!isEditMode && maxAllowedStep < 2}
          >
            {t("criteria")}
          </button>
          <button
            className={`${styles.tabButton} ${
              activeTab === 3 ? styles.activeTab : ""
            }`}
            style={{
              borderTopRightRadius: "10px",
              opacity: (isEditMode || maxAllowedStep >= 3) ? 1 : 0.6,
              cursor: (isEditMode || maxAllowedStep >= 3) ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (isEditMode || maxAllowedStep >= 3) {
                setStep(3);
                setActiveTab(3);
              }
            }}
            disabled={!isEditMode && maxAllowedStep < 3}
          >
            {t("showcase")}
          </button>
        </div>

        {step === 1 && (
          <>
            <h3 className={styles.sectionHeader}>{t("property_type")}</h3>
            <div
              className={styles.radioGroup}
              style={{ flexDirection: "row", gap: "10px", flexWrap: "wrap" }}
            >
              {["House/Villa", "Apartment", "Multifamily", "Plot"]
                .filter((typeDisplayString) => {
                  if (
                    formData.offeringType === "rental" &&
                    (typeDisplayString === "Multifamily" ||
                      typeDisplayString === "Plot")
                  ) {
                    return false;
                  }
                  return true;
                })
                .map((typeDisplayString) => {
                  const jsonKey = displayStringToKeyMap[typeDisplayString];

                  if (!jsonKey) {
                    console.warn(
                      `Translation key missing for display string: "${typeDisplayString}". Please ensure it's mapped in 'displayStringToKeyMap'.`
                    );
                    return null;
                  }

                  const isChecked = formData.propertyType === jsonKey;

                  return (
                    <label key={jsonKey} className={styles.radioLabel}>
                      <input
                        type="radio"
                        name="propertyType"
                        checked={isChecked}
                        onChange={() =>
                          handleRadioChange("propertyType", jsonKey)
                        }
                        className={styles.radioInput}
                      />
                      <span className={styles.radioCustom}>
                        {isChecked && <span className={styles.radioDot}></span>}
                      </span>
                      {t(jsonKey)}
                    </label>
                  );
                })}
            </div>

            <h3 className={styles.sectionHeader}>{t("Looking-for")}..</h3>
            <div
              className={styles.radioGroup}
              style={{ flexDirection: "row", gap: "26px" }}
            >
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="offeringType"
                  checked={formData.offeringType === "purchase"}
                  onChange={() => handleRadioChange("offeringType", "purchase")}
                  className={styles.radioInput}
                />
                <span className={styles.radioCustom}>
                  {formData.offeringType === "purchase" && (
                    <span className={styles.radioDot}></span>
                  )}
                </span>
                {t("sale")}
              </label>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="offeringType"
                  checked={formData.offeringType === "rental"}
                  onChange={() => handleRadioChange("offeringType", "rental")}
                  className={styles.radioInput}
                />
                <span className={styles.radioCustom}>
                  {formData.offeringType === "rental" && (
                    <span className={styles.radioDot}></span>
                  )}
                </span>
                {t("rent")}
              </label>
            </div>
            <h3 className={styles.sectionHeader}> {t("property_title")}</h3>
            <div className={styles.addressInputContainer}>
              <input
                value={formData.propertyTitle}
                type="text"
                name="propertyTitle"
                placeholder={`${t("property_title_placeholder")} *`}
                className={`${styles.textInputUnit} ${styles.textPropertyTitle} ${
                  validationErrors.propertyTitle ? styles.errorInput : ""
                }`}
                onChange={handleChange}
                maxLength={50}
              />
              <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                {formData.propertyTitle.length}/50
              </div>
            </div>

            <h3 className={styles.sectionHeader}> {t("description_label")}</h3>
            <div className={styles.addressInputContainer}>
              <textarea
                value={formData.description}
                name="description"
                placeholder={t("description_placeholder")}
                className={`${styles.textInputUnit} ${styles.textareaInput} ${
                  validationErrors.description ? styles.errorInput : ""
                }`}
                onChange={handleChange}
                maxLength={500}
                rows={4}
              />
              <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                {formData.description.length}/500
              </div>
            </div>

            <h3 className={styles.sectionHeader}> {t("address")}</h3>
            <div className={styles.addressInputContainer}>
              <div className={styles.addressMainInputWrapper}>
                <Autocomplete
                  apiKey={api_Key}
                  onPlaceSelected={async (place) => {
                    const placeId = place?.place_id;
                    console.log("Place ID:", place);

                    const addressComponents = place.address_components;
                    const getComponent = (type) => {
                      const component = addressComponents.find((comp) =>
                        comp.types.includes(type)
                      );
                      return component ? component.long_name : "";
                    };

                    const streetNumber = getComponent("street_number") || '';
                    const streetName =
                      (getComponent("route") ||
                      getComponent("point_of_interest") ||
                      getComponent("establishment") || '') + " " + (streetNumber ? streetNumber + ' ' : '');

                    const country = getComponent("country");
                    const city =
                      getComponent("locality") ||
                      getComponent("administrative_area_level_2") ||
                      getComponent("administrative_area_level_1");
                    const zipcode = getComponent("postal_code");

                    setFormData((prev) => ({
                      ...prev,
                      address: streetName,
                      country,
                      city,
                      zipcode,
                    }));
                  }}
                  value={formData.address}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      address: e.target.value,
                    }));
                  }}
                  options={{
                    types: ["address"],
                    componentRestrictions: { country: "ch" },
                  }}
                  placeholder={`${t("address_label")} *`}
                  className={`${styles.addressInput} ${
                    validationErrors.address ? styles.errorInput : ""
                  }`}
                />
              </div>
              <div className={styles.addressSubInputs}>
                <input
                  name="zipcode"
                  value={formData.zipcode}
                  onChange={handleChange}
                  type="text"
                  placeholder={`${t("Zip")} *`}
                  className={`${styles.addressSubInputZip} ${
                    validationErrors.zipcode ? styles.errorInput : ""
                  }`}
                />
                <input
                  value={formData.city}
                  readOnly
                  type="text"
                  placeholder={`${t("City")} *`}
                  className={`${styles.addressSubInputCH} ${
                    validationErrors.city ? styles.errorInput : ""
                  }`}
                />
                <input
                  value={formData.country}
                  readOnly
                  type="text"
                  placeholder={`${t("country")} *`}
                  className={`${styles.addressSubInputCH} ${
                    validationErrors.country ? styles.errorInput : ""
                  }`}
                />
              </div>
            </div>

            <div className={styles.responsiveContainer}>
            <div className={styles.priceInputContainer}>
            <h3 className={styles.sectionHeader}>
              {formData.offeringType === "rental"
                ? t("Price CHF / Monthly")
                : t("price")}
            </h3>
            <input
              type="text"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className={`${styles.textInput1} ${
                validationErrors.price ? styles.errorInput : ""
              }`}
              placeholder={`${formData.offeringType === "rental"
                ? t("Price CHF / Monthly")
                : t("price")} *`}
            />
</div>
            <div className={styles.bedroomsSquareFootageRow}>
              {formData.propertyType !== "plot" &&
                formData.propertyType !== "multifamily" && (
                  <div className={styles.bedroomsInputContainer}>
                    <h3 className={styles.sectionHeader}>{t("no_of_bedrooms")}</h3>
                    <select
                      name="bedrooms"
                      value={formData.bedrooms}
                      onChange={handleChange}
                      className={`${styles.textInputbedroom} ${
                        validationErrors.bedrooms ? styles.errorInput : ""
                      } ${
                        !formData.bedrooms ? styles.placeholderSelect : ""
                      }`}
                    >
                      <option value="" disabled>
                        {`${t("Select bedrooms")} *`}
                      </option>
                      {bedroomOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              {formData.propertyType === "multifamily" && (
                <div className={styles.unitsInputContainer}>
                  <h3 className={styles.sectionHeader}>{t("Unit")}</h3>
                  <input
                    type="text"
                    name="units"
                    value={formData.units}
                    onChange={handleChange}
                    className={`${styles.textInput1} ${
                      validationErrors.units ? styles.errorInput : ""
                    }`}
                    placeholder={`${t("Units")} *`}
                  />
                </div>
              )}
              {formData.propertyType === "plot" && (
                <div className={styles.indexInputContainer}>
                  <h3 className={styles.sectionHeader}>{t("Index")}</h3>
                  <input
                    type="number"
                    step="0.01"
                    name="index"
                    value={formData.index}
                    onChange={handleChange}
                    className={`${styles.textInput1} ${
                      validationErrors.index ? styles.errorInput : ""
                    }`}
                    placeholder={`${t("Index")} *`}
                  />
                </div>
              )}
            </div>
            <div className={styles.squareFootageInputContainer}>
              <h3 className={styles.sectionHeader}>{t("plsqft")}</h3>
              <input
                type="text"
                name="squareFootage"
                value={formData.squareFootage}
                onChange={handleChange}
                className={`${styles.textInput1} ${
                  validationErrors.squareFootage ? styles.errorInput : ""
                }`}
                placeholder={`${t("plsqft")} *`}
              />
            </div>

</div>
            <div style={{ marginTop: '30px'}}>
              <button
                type="button"
                onClick={handleNextStep}
                className={styles.nextButton}
                style={{ marginLeft: '335px' }}
              >
                {t("next")}
              </button>
            </div>
         
          </>
        )}

        {step === 2 && (
          <>
            {loadingCriteria ? (
              <div style={{ padding: '40px', textAlign: 'center' }}>
                <p>Loading criteria options...</p>
              </div>
            ) : criteriaGroups.length === 0 ? (
              <div style={{ padding: '40px', textAlign: 'center', color: 'red' }}>
                <p>No criteria options available. Please check API connection.</p>
              </div>
            ) : (
              <div className={styles.criteriaGrid}>
                {criteriaGroups.map((group, groupIndex) => {
                  // Use the isMultiSelect flag from admin configuration
                  // Some criteria (like facilities) can have multiple values for offers
                  // Others (like roof, condition) should be single-select based on admin config
                  const isMultiselect = group.isMultiSelect || group.multiselect;
                  console.log(
                    `🔍 Rendering group: ${group.groupName}, isMultiSelect: ${group.isMultiSelect}, isMultiselect: ${isMultiselect}, values:`, group.values
                  );

                  return (
                    <React.Fragment key={group.groupName}>
                      {group.groupName !== "default_criteria" && (
                        <>
                          {group.values && group.values.length > 0 ? (
                            group.values.map((value, valueIndex) => {
                              // Extract both display value and identifier from value
                              const displayValue = getDisplayValue(value);
                              const identifier = getIdentifier(value);

                              // Use identifier-based comparison to handle both old and new formats
                              const isChecked = isMultiselect
                                ? isCriteriaSelected(formData[group.groupName] || [], value)
                                : getIdentifier(formData[group.groupName]) === getIdentifier(value);

                              return (
                                <div
                                  key={`${group.groupName}-${valueIndex}`}
                                  className={styles.criteriaItem}
                                >
                                  <label className={styles.radioLabel}>
                                    <input
                                      type={isMultiselect ? "checkbox" : "radio"}
                                      name={group.groupName}
                                      checked={isChecked}
                                      onChange={() =>
                                        isMultiselect
                                          ? handleCheckboxChange2(
                                              group.groupName,
                                              identifier
                                            )
                                          : handleRadioChange2(
                                              group.groupName,
                                              identifier
                                            )
                                      }
                                      className={styles.radioInput}
                                    />
                                    <span className={styles.radioCustom}>
                                      {isChecked &&
                                        (isMultiselect ? (
                                          <span className={styles.radioDot2}>
                                            <span
                                              className={styles.tickMark}
                                            ></span>
                                          </span>
                                        ) : (
                                          <span className={styles.radioDot}></span>
                                        ))}
                                    </span>
                                    {displayValue}
                                  </label>
                                </div>
                              );
                            })
                          ) : (
                            <div style={{ padding: '10px', color: '#999' }}>
                              No options for {group.groupName}
                            </div>
                          )}
                        </>
                      )}
                    </React.Fragment>
                );
              })}
              </div>
            )}

            <div style={{ marginTop: '30px', paddingBottom: '140px', display: 'flex', gap: '12px' }}>
              <button
                type="button"
                onClick={prevStep}
                className={styles.backButton}
              >
                {t("Back")}
              </button>
              <button
                type="button"
                onClick={nextStep}
                className={styles.nextButton2}
                style={{ marginLeft: '335px' }}
              >
                {t("next")}
              </button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            {/* Image Upload Section */}
            <div>
              <div>
                <input
                  {...getInputProps()}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />

                {uploadedImages.length === 0 ? (
                  <div
                    {...getRootProps()}
                    className={`${styles.dropzone} ${
                      isDragActive
                        ? styles.dropzoneActive
                        : styles.dropzoneDefault
                    }`}
                  >
                    {isDragActive ? (
                      <p className={styles.dropzoneText}>
                        {t("drop_images_here")}
                      </p>
                    ) : (
                      <div className={styles.uploadInstructions}>
                        <p className={styles.dropzoneText}>
                          {t("drag_drop_images_here")}
                        </p>
                        <p className={styles.dropzoneText}>{t("or")}</p>
                        <button
                          type="button"
                          className={styles.uploadButton}
                          onClick={handleClickUpload}
                        >
                          {t("uploadimage")}
                        </button>
                        <p className={styles.dropzoneHint}>
                          ({t("Select_Up_To_6_Images")})
                        </p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <h3 className={styles.uploadedImagesHeader}>
                      {t("uploaded_images")} ({uploadedImages.length}/6)
                    </h3>
                    <div className={styles.imageGrid}>
                      {uploadedImages.map((file) => (
                        <div key={file.id} className={styles.imageUploadBox}>
                          <div className={styles.previewImageContainer}>
                            <img
                              src={file.url}
                              alt={file.fileName || `Preview ${file.id}`}
                              className={styles.previewImage}
                            />
                            {file.isMain && (
                              <div
                                className={styles.mainImageStarIndicator}
                                dangerouslySetInnerHTML={{ __html: starIcon }}
                              ></div>
                            )}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                removeImage(file.id);
                              }}
                              className={styles.deleteButtonSmall}
                            >
                              <img src={deleteIcon} alt="Delete" />
                            </button>
                          </div>
                        </div>
                      ))}

                      {Array.from({ length: 6 - uploadedImages.length }).map(
                        (_, index) => (
                          <div
                            key={`empty-${index}`}
                            className={styles.imageUploadBox}
                            onClick={handleClickUpload}
                          >
                            <div className={styles.emptyImageBox}>
                              <div className={styles.emptyImageBoxClickText}>
                                {t("uploadimage")}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    {uploadedImages.length > 0 && (
                      <button
                        type="button"
                        onClick={() => setShowMainImageModal(true)}
                        className={styles.selectMainImageButton}
                      >
                        {t("Set_Main_Image")}
                      </button>
                    )}

                    {uploadedImages.length < 6 && (
                      <div
                        {...getRootProps()}
                        className={`${styles.addMoreContainer} ${
                          isDragActive
                            ? styles.dropzoneActive
                            : styles.dropzoneDefault
                        }`}
                      >
                        <p className={styles.addMoreText}>
                          {isDragActive
                            ? t("drop_to_add_more_images")
                            : `${t("drag_drop_click_add_more")} (${
                                6 - uploadedImages.length
                              } remaining)`}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Main Image Modal */}
            {showMainImageModal && (
              <Modal onClose={() => setShowMainImageModal(false)}>
                <div className={styles.modalHeader}>
                  <h3 className={styles.modalHeaderH3}>
                    {" "}
                    {t("Set_Main_image")}
                  </h3>
                  <button
                    onClick={() => setShowMainImageModal(false)}
                    className={styles.modalCloseButton}
                  >
                    &times;
                  </button>
                </div>
                <div className={styles.modalImageGrid}>
                  {uploadedImages.map((img) => (
                    <div
                      key={img.id}
                      className={`${styles.modalImageItem} ${
                        img.isMain ? styles.modalImageItemSelected : ""
                      }`}
                      onClick={() => selectMainImage(img.id)}
                    >
                      <img
                        src={img.url}
                        alt={img.fileName || "Property Image"}
                      />
                      <div className={styles.overlay}>
                        {img.isMain ? "MAIN IMAGE" : "Click to Set Main"}
                      </div>
                    </div>
                  ))}
                </div>
              </Modal>
            )}

            {/* Two Column Input Layout */}
            <div className={styles.twoColumnLayout}>
              {/* First Column */}
              <div className={styles.column}>
                <div className={styles.publicHeadingContainer}>
                  <span className={styles.publicHeading}>
                    {" "}
                    {t("public-visible")}
                  </span>
                </div>

                {/* Vendor Name */}
                <div className={styles.inputWithIconCheckbox}>
                  <div className={styles.inputIcon}>
                    <img
                      src={vendorIcon}
                      alt="Vendor"
                      className={styles.iconImage}
                    />
                  </div>
                  <input
                    type="text"
                    name="vendorName"
                    value={formData.vendorName}
                    onChange={handleChange}
                    className={`${styles.textInput} ${
                      validationErrors.vendorName ? styles.errorInput : ""
                    }`}
                    placeholder={`${t("insert-vendor")} *`}
                    required
                  />
                  <input
                    type="checkbox"
                    name="vendorNamePublic"
                    checked={formData.vendorNamePublic}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxShowcase}
                  />
                </div>

                {/* Email */}
                <div className={styles.inputWithIconCheckbox}>
                  <div className={styles.inputIcon}>
                    <img
                      src={emailIcon}
                      alt="Email"
                      className={styles.iconImage}
                    />
                  </div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`${styles.textInput} ${
                      validationErrors.email ? styles.errorInput : ""
                    }`}
                    placeholder={`${t("insert-email")} *`}
                    required
                  />
                  <input
                    type="checkbox"
                    name="emailPublic"
                    checked={formData.emailPublic}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxShowcase}
                  />
                </div>
                {errors.email && (
                  <div className={styles.errorMessageEmail}>{errors.email}</div>
                )}

                {/* Phone Number */}
                {errors.phone && (
                  <div className={styles.errorMessagePhone}>{errors.phone}</div>
                )}
                <div className={styles.inputWithIconCheckbox}>
                  <div className={styles.inputIcon}>
                    <img
                      src={mobileIcon}
                      alt="Mobile"
                      className={styles.iconImage}
                    />
                  </div>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`${styles.textInput} ${
                      validationErrors.phone ? styles.errorInput : ""
                    }`}
                    onBlur={handleBlur}
                    placeholder={`${t("Mobile_Format")} *`}
                    required
                  />
                  <input
                    type="checkbox"
                    name="phonePublic"
                    checked={formData.phonePublic}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxShowcase}
                  />
                </div>

                {/* Available Days */}
                <div className={styles.inputWithIconCheckbox}>
                  <div className={styles.inputIcon}>
                    <img
                      src={timeIcon}
                      alt="Calendar"
                      className={styles.iconImage}
                    />
                  </div>
                  <select
                    name="contactTime"
                    value={formData.contactTime}
                    onChange={handleChange}
                    className={`${styles.textInput} ${
                      formData.contactTime === "" ? styles.placeholderColor : ""
                    }`}
                  >
                    <option value="" disabled>
                      {t("select_availability_placeholder")}
                    </option>
                    <option value="08:00 - 10:00">08:00 - 10:00</option>
                    <option value="10:00 - 12:00">10:00 - 12:00</option>
                    <option value="12:00 - 14:00">12:00 - 14:00</option>
                    <option value="14:00 - 16:00">14:00 - 16:00</option>
                    <option value="16:00 - 18:00">16:00 - 18:00</option>
                    <option value="18:00 - 20:00">18:00 - 20:00</option>
                  </select>
                  <input
                    type="checkbox"
                    name="contactTimeVisible"
                    checked={formData.contactTimeVisible}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxShowcase}
                  />
                </div>

              </div>

              {/* Second Column */}
              <div className={styles.column}>
                <div className={styles.publicHeadingContainer}>
                  <span className={styles.publicHeading}>
                    {t("public-visible")}
                  </span>
                </div>

                {/* Design Pictures (readOnly, no validation) */}
                <div>
                  <div className={styles.inputWithIconCheckbox}>
                    <div className={styles.inputIcon}>
                      <img
                        src={arcthect}
                        alt="Architect"
                        className={styles.iconImage}
                      />
                    </div>
                    <input
                      type="text"
                      name="designImages"
                      value={formData.designFilename || ""}
                      readOnly
                      onChange={handleChange}
                      className={styles.textInput}
                      placeholder={`${t("upload-design")} ${t("max_size_10mb")}`}
                      onClick={() =>
                        document.getElementById("design-upload").click()
                      }
                    />
                    <input
                      type="file"
                      id="design-upload"
                      accept=".pdf"
                      style={{ display: "none" }}
                      onChange={handleDesignUpload}
                    />
                    <input
                      type="checkbox"
                      name="designPublic"
                      checked={formData.designPublic}
                      onChange={handleCheckboxChange}
                      className={styles.checkboxShowcase}
                    />
                  </div>
                  {/* <div style={{ fontSize: "12px",fontWeight: 800, color: "#666", marginTop: "-25px", marginLeft: "50px", marginBottom: "15px" }}>
                    {t("max_size_10mb") || "Max size: 10MB"}
                  </div> */}
                </div>

                {/* Website URL */}
                <div className={styles.inputWithIconCheckbox}>
                  <div className={styles.inputIcon}>
                    <img
                      src={globalIcon}
                      alt="Web Link"
                      className={styles.iconImage}
                    />
                  </div>
                  <input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={t("web-url")}
                    className={`${styles.textInput} ${
                      errors.website ? styles.errorInput : ""
                    }`}
                  />
                  <input
                    type="checkbox"
                    name="websitePublic"
                    checked={formData.websitePublic}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxShowcase}
                  />
                </div>
                {errors.website && (
                  <div className={styles.errorMessage}>{errors.website}</div>
                )}

                {/* Virtual Tour Link */}
                <div className={styles.inputWithIconCheckbox}>
                  <div className={styles.inputIcon}>
                    <img
                      src={virtualTour}
                      alt="Virtual Tour"
                      className={styles.iconImage}
                    />
                  </div>
                  <input
                    type="text"
                    name="link2"
                    value={formData.link2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`${styles.textInput} ${
                      errors.link2 ? styles.errorInput : ""
                    }`}
                    placeholder={t("insert-link")}
                    required
                  />
                  <input
                    type="checkbox"
                    name="link2Public"
                    checked={formData.link2Public}
                    onChange={handleCheckboxChange}
                    className={styles.checkboxShowcase}
                  />
                </div>
                {errors.link2 && (
                  <div className={styles.errorMessage}>{errors.link2}</div>
                )}

                {/* Brochure PDF (readOnly, no validation) */}
                <div>
                  <div className={styles.inputWithIconCheckbox}>
                    <div className={styles.inputIcon}>
                      <img src={pdfIcon} alt="PDF" className={styles.iconImage} />
                    </div>
                    <input
                      type="text"
                      name="brochure"
                      value={formData.brochureFilename}
                      readOnly
                      className={styles.textInput}
                      placeholder={`${t("upload-brochure")} ${t("max_size_10mb")}`}
                      onClick={() =>
                        document.getElementById("brochure-upload").click()
                      }
                    />
                    <input
                      type="file"
                      id="brochure-upload"
                      accept=".pdf"
                      style={{ display: "none" }}
                      onChange={handleBrochureUpload}
                    />
                    <input
                      type="checkbox"
                      name="brochurePublic"
                      checked={formData.brochurePublic}
                      onChange={handleCheckboxChange}
                      className={styles.checkboxShowcase}
                    />
                  </div>
                  {/* <div style={{ fontSize: "12px",fontWeight: 800, color: "#666", marginTop: "-25px", marginLeft: "50px", marginBottom: "15px" }}>
                    {t("max_size_10mb") || "Max size: 10MB"}
                  </div> */}
                </div>
              </div>
            </div>
            <div style={{ marginTop: '20px' }}>
              <span
                className={styles.publicHeading}
                style={{
                  color: (
                    Object.keys(validationErrors).length > 0 ||
                    Object.values(errors).some(err => err !== "") ||
                    !formData.vendorName ||
                    !formData.email ||
                    !formData.phone ||
                    uploadedImages.length === 0
                  ) ? 'red' : '#000',
                  fontWeight: (
                    Object.keys(validationErrors).length > 0 ||
                    Object.values(errors).some(err => err !== "") ||
                    !formData.vendorName ||
                    !formData.email ||
                    !formData.phone ||
                    uploadedImages.length === 0
                  ) ? '600' : 'normal'
                }}
              >
                {t("note_asterisk")}
              </span>
            </div>
            <div style={{ marginTop: '12px', display: 'flex', gap: '12px' }}>
              <button type="button" onClick={prevStep} className={styles.backButton}>{t("Back")}</button>
              <button type="button" onClick={handleSubmit} className={styles.publishButton} style={{ marginLeft: '900px' }}>{t("Publish")}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// const styles = {
//   container: {
//     display: 'flex',
//     minHeight: '100vh',
//     // fontFamily: 'Arial, sans-serif'
//   },

//   addressInputContainer: {
//     display: 'flex',
//     gap: '10px',
//     alignItems: 'center',
//     marginBottom: '20px'
//   },
//   addressSubInputs: {
//     display: 'flex',
//     gap: '10px',
//   },
//   addressSubInputCH: {
//     padding: '12px 15px',
//     backgroundColor: 'rgba(247, 250, 252, 1)',
//     border: '1px solid #ddd',
//     borderRadius: '4px',
//     fontSize: '18px',
//     fontWeight: '400',
//     width: '80px'
//   },
//   addressSubInputZip: {
//     padding: '12px 15px',
//     backgroundColor: 'rgba(247, 250, 252, 1)',
//     border: '1px solid #ddd',
//     borderRadius: '4px',
//     fontSize: '18px',
//     fontWeight: '400',
//     width: '40px'
//   },
//   addressInput: {
//     padding: '12px 15px',
//     backgroundColor: 'rgba(247, 250, 252, 1)',
//     border: '1px solid #ddd',
//     borderRadius: '4px',
//     fontSize: '18px',
//     fontWeight: '400',
//     width: '200px',
//     flex: 1
//   },

//   bedroomsSquareFootageRow: {
//     display: 'flex',
//     gap: '20px'
//   },
//   bedroomsInputContainer: {
//     flex: 1
//   },
//   squareFootageInputContainer: {
//     flex: 3
//   },
//   leftPanel: {
//     width: '280px', // Fixed width for the left panel. Adjust as needed.
//     flexShrink: 0, // Prevents the left panel from shrinking
//     padding: '15px', // Slightly increased padding for better spacing
//     backgroundColor: 'white',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.08)', // Added shadow for consistency
//     borderRight: '1px solid #ddd',
//     marginRight: '5px', // Space between left panel and main content
//     alignSelf: 'flex-start', // Aligns to the top
//   },

//   rightPanel: {
//     // flex: 1.5,
//     width: '80%',
//     padding: '20px',
//     backgroundColor: '#fff',
//   },
//   tabContainer: {
//     // display: 'flex',
//     marginBottom: '20px',
//     // borderBottom: '1px solid #ddd'
//   },
//   tabButton: {
//     padding: '13px 32px',
//     backgroundColor: 'rgba(204, 204, 204, 0.4)',
//     border: 'none',
//     cursor: 'pointer',
//     fontWeight: '400',
//     fontSize: '18px',
//     color: 'black',
//     position: 'relative',
//     // marginRight: '0px',
//     // borderRadius: '3px'
//   },
//   activeTab: {
//     color: '#2196F3',
//     fontWeight: '400',
//     // borderBottom: '2px solid #2196F3'
//   },
//   trendingHeader: {
//     fontSize: '22px',
//     fontWeight: '700',
//     color: 'rgba(41, 177, 133, 1)',
//     marginBottom: '15px', // Increased margin-bottom for spacing
//     marginTop: '15px',
//     textAlign: 'center',
//     textShadow: '10px 4px 5px rgba(0, 0, 0, 0.36)'
//   },

//   propertyCard: {
//     marginBottom: '20px',
//     backgroundColor: 'White',
//     borderRadius: '8px',
//     padding: '10px',
//     boxShadow: '-1px -1px 4px rgba(0, 0, 0, 0.1), 7px 7px 4px rgba(0, 0, 0, 0.1)'
//   },

//   propertyImg: { // Style for the actual image tag inside propertyImage
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover', // Ensures the image covers the area without distortion
//   },

//   propertyImg2: {
//     width: '100%',
//     height: '120%',
//     objectFit: 'cover',
//     borderRadius: '4px'
//   },
//   propertyImage: {
//     width: '100%', // Make image take full width of card
//     height: '150px',
//     backgroundColor: '#ddd',
//     marginBottom: '10px',
//     borderRadius: '4px',
//     overflow: 'hidden',
//   },

//   propertyImage2: {
//     height: '200px',
//     backgroundColor: '#ddd',
//     marginBottom: '10px',
//     borderRadius: '4px',
//     overflow: 'hidden'
//   },

//   propertyText: {
//     fontSize: '16px',
//     color: '#555',
//     textAlign: 'center', // Center the text within the property card
//   },

//   pageHeader: {
//     fontSize: '18px',
//     color: 'rgb(6 121 95)',
//     marginBottom: '30px',
//     paddingBottom: '10px',
//     borderBottom: '1px solid #eee'
//   },
//   sectionHeader: {
//     color: 'rgba(41, 177, 133, 1)',
//     fontSize: '24px',
//     marginBottom: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//   },
//   radioGroup: {
//     display: 'flex',
//     gap: '10px',
//     marginBottom: '20px'
//   },

//   radioLabel: {
//     display: 'flex',
//     alignItems: 'center',
//     cursor: 'pointer',
//     position: 'relative',
//     paddingLeft: '25px',
//     fontSize: '18px',
//     fontWeight: 400,
//     paddingRight: '10px',
//     whiteSpace: 'normal',
//     wordBreak: 'break-word',
//     lineHeight: '1.2',
//   },

//   radioLabelLast: {
//     display: 'flex',
//     gridColumn: '1 / -1',
//     alignItems: 'center',
//     cursor: 'pointer',
//     position: 'relative',
//     paddingLeft: '32px',
//     fontSize: '18px',
//     fontWeight: 400,
//     paddingRight: '10px', // Consistent padding
//     whiteSpace: 'normal',
//     wordBreak: 'break-word',
//     lineHeight: '1.2',
//     minHeight: '24px',
//   },
//   radioInput: {
//     position: 'absolute',
//     alignItems: 'center',
//     opacity: 0,
//     cursor: 'pointer',
//     height: 0,
//     width: 0,
//     left: 0,
//     top: '50%',
//     transform: 'translateY(-50%)'
//   },
//   radioCustom: {
//     position: 'absolute',
//     left: 0,
//     top: '50%',
//     transform: 'translateY(-50%)',
//     height: '18px',
//     width: '18px',
//     border: '2px solid #29b185',
//     borderRadius: '50%',
//     background: '#fff',
//     boxSizing: 'border-box',
//     transition: 'border-color 0.2s'
//   },
//   radioDot: {
//     content: '""',
//     position: 'absolute',
//     left: '50%',
//     top: '50%',
//     transform: 'translate(-50%, -50%)',
//     height: '8px',
//     width: '8px',
//     borderRadius: '50%',
//     background: '#29b185'
//   },
//    textInputbedroom: {
//     padding: '12px 15px',
//     border: '1px solid #ddd',
//     borderRadius: '4px',
//     fontSize: '18px',
//     fontWeight: '400',
//     width: '250px',
//     backgroundColor: 'rgba(247, 250, 252, 1)',
//     color: 'black',
//     marginBottom: '15px',
//     flex: 1
//   },
//   textInput: {
//     padding: '12px 20px',
//     backgroundColor: 'rgba(0, 0, 0, 0.2)',
//     color: 'white',
//     border: '1px solid #ddd',
//     borderRadius: '4px',
//     fontSize: '18px',
//     fontWeight: '400',
//     width: '269px',
//     // height:'20px',
//     marginBottom: '15px',
//     flex: 1
//   },
//   textInput1: {
//     padding: '12px 15px',
//     backgroundColor: 'rgba(247, 250, 252, 1)',
//     border: '1px solid #ddd',
//     borderRadius: '4px',
//     fontSize: '18px',
//     fontWeight: '400',
//     width: '237px',
//     marginBottom: '15px',
//     flex: 1
//   },
//   criteriaRowContainer: {
//     display: 'contents'
//   },
//   criteriaRowBorder: {
//     gridColumn: '1 / -1', // Ensure border spans all columns
//     borderBottom: '1px solid #e0e0e0', // Light grey border
//     height: '1px', // Minimal height for the line
//     margin: '10px 0', // Vertical spacing for the border
//     // Add clear: 'both' if using floats somewhere else, but typically not needed with grid
//   },
//   criteriaGrid: {
//     display: 'grid',
//     // Revert to simple 1fr for even distribution initially,
//     // as minmax seemed to cause issues with your specific content.
//     gridTemplateColumns: 'repeat(3, 1fr)',
//     // Adjust gap. A smaller gap might be better if you're controlling padding/margin on labels.
//     gap: '0px', // Uniform gap between grid items
//     marginBottom: '10px',
//     // The fixed width: '550px' was likely the main culprit for overflow in the first place.
//     // If you absolutely need a fixed width, make sure it's wide enough for all content.
//     // Consider using 'maxWidth' instead of 'width' for responsiveness.
//     // Let's keep it for now as it was in your original, but understand it restricts space.
//     width: '465px',
//     // The marginRight: '400px' was commented out, leave it that way unless specifically needed for positioning the entire block.
//     // marginRight: '400px', // Keep commented out
//   },
//   criteriaItem: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     fontSize: '18px',
//     fontWeight: '400'
//   },
//   checkbox: {
//     // width: '18px',
//     // height: '18px',
//     marginLeft: '10px',
//     accentColor: 'rgba(41, 177, 133, 1)',
//     transform: 'scale(1.6)', // or any scale you want
//     verticalAlign: 'middle',
//   },
//   dropzone: {
//     flex: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px',
//     borderWidth: 2,
//     borderRadius: 15,
//     borderColor: '#eeeeee',
//     borderStyle: 'dashed',
//     backgroundColor: 'white', // Dark background
//     color: '#bdbdbd',
//     outline: 'none',
//     transition: 'border .24s ease-in-out',
//     cursor: 'pointer',
//     minHeight: '200px',
//     marginBottom: '20px',
//   },
//   dropzoneText: {
//     fontSize: '18px',
//     color: '#555',
//     margin: '8px 0',
//   },
//   uploadInstructions: {
//     textAlign: 'center',
//   },
//   uploadButton: {
//     backgroundColor: 'rgba(41, 177, 133, 1)',
//     color: 'white',
//     padding: '10px 20px',
//     borderRadius: '8px',
//     border: 'none',
//     cursor: 'pointer',
//     fontSize: '16px',
//     fontWeight: 'bold',
//     marginTop: '10px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//   },
//   dropzoneHint: {
//     fontSize: '14px',
//     color: '#888',
//     marginTop: '10px',
//   },

//   deleteButton: {
//     position: 'absolute',
//     top: '5px',
//     right: '5px',
//     backgroundColor: 'rgba(255, 0, 0, 0.7)',
//     border: 'none',
//     borderRadius: '50%',
//     width: '30px',
//     height: '30px',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     cursor: 'pointer',
//     zIndex: 5,
//   },
//   emptyImageBox: {
//     width: '284',
//     height: '160',
//     backgroundColor: 'white',
//     // borderRadius: '8px',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     color: 'rgb(255, 255, 255)',
//     textAlign: 'center',
//     fontSize: '14px',
//     cursor: 'pointer',
//   },
//   addMoreContainer: {
//     flex: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px',
//     borderWidth: 2,
//     borderRadius: 15,
//     borderColor: '#ddd',
//     borderStyle: 'dashed',
//     backgroundColor: 'white',
//     color: '#bdbdbd',
//     outline: 'none',
//     transition: 'border .24s ease-in-out',
//     cursor: 'pointer',
//     minHeight: '100px',
//     marginTop: '15px',
//   },
//   errorMessage: {
//     color: 'red',
//     fontSize: '14px',
//     marginTop: '-10px',
//     marginBottom: '10px',

//     marginLeft: '70px',

//   },
//   errorMessageEmail: {
//     color: 'red',
//     fontSize: '14px',
//     marginTop: '-10px',
//     marginBottom: '10px',

//     marginLeft: '70px',

//   },
//   errorMessagePhone: {
//     color: 'red',
//     fontSize: '14px',
//     marginTop: '-10px',
//     marginBottom: '10px',

//     marginLeft: '70px',

//   },
//   addMoreText: {
//     color: 'black',
//     margin: '0',
//     textAlign: 'center',
//   },

//   imageGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(3, 1fr)',
//     gap: '10px',
//     marginBottom: '20px',

//   },
//   mainImageStarIndicator: {
//     position: 'absolute',
//     top: '5px',
//     right: '5px',
//     color: 'gold', // Gold color for the star
//     zIndex: 10,
//     width: '20px', // Size of the star
//     height: '20px',
//     filter: 'drop-shadow(0px 0px 2px rgba(0,0,0,0.7))', // Small shadow for visibility
//   },

//   imageUploadBox: {
//     backgroundColor: 'white',
//     // borderRadius: '10px',
//     border: '1px solid #333',
//     overflow: 'hidden',
//     position: 'relative', // For absolute positioning of delete/main button
//     padding: '10px', // Added padding for better visual
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     width: '284px',
//     height: '160px',
//     boxSizing: 'border-box',
//   },

//   previewImageContainer: {
//     position: 'relative',
//     width: '100%',
//     height: '100%',
//     overflow: 'hidden',

//   },
//   selectMainImageButton: {
//     backgroundColor: 'rgba(41, 177, 133, 1)',
//     color: 'white',
//     border: 'none',
//     padding: '10px 20px',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '16px',
//     fontWeight: 'bold',
//     marginTop: '20px',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
//     transition: 'background-color 0.3s ease, transform 0.2s ease',
//     '&:hover': {
//       backgroundColor: 'rgba(41, 177, 133, 0.9)',
//       transform: 'translateY(-2px)',
//     },
//     display: 'block',
//     margin: '20px auto 0 auto',
//   },

//   previewImage: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//     display: 'block',

//   },

//   fileInput: {
//     width: '100%',
//     marginBottom: '30px',
//   },
//   twoColumnLayout: {
//     display: 'flex',
//     gap: '20px'
//   },
//   column: {
//     flex: 1,
//   },
//   publicHeadingContainer: {
//     marginTop: '15px',
//     marginBottom: '15px',
//     justifyContent: 'flex-end',

//     marginLeft: '360px' // Align with checkboxes
//   },
//   publicHeading: {
//     color: 'black',
//     fontSize: '20px', // Smaller heading
//     fontWeight: '400',
//     lineHeigth: "22px"
//   },
//   inputWithIconCheckbox: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '20px',
//     marginBottom: '15px',
//     // marginRight: '10px',
//     width: '400px',
//     height: '60px',

//   },
//   inputIcon: {
//     // fontSize: '20px',
//     width: '30px',
//     height: '30px',
//     display: 'flex',
//     justifyContent: 'center'
//   },
//   navigation: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     marginTop: '30px'
//   },
//   backButton: {
//     padding: '12px 25px',
//     backgroundColor: '#f0f0f0',
//     color: 'black',
//     border: 'none',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '20px'
//   },
//   nextButton: {
//     padding: '12px 25px',
//     backgroundColor: 'rgba(41, 177, 133, 1)',
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '20px',
//     marginLeft: '650px',
//   },
//   nextButton2: {
//     padding: '12px 25px',
//     backgroundColor: 'rgba(41, 177, 133, 1)',
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '20px',
//     // marginLeft:'650px',
//     marginRight: '200px',
//   },
//   link: {
//     textDecoration: "none",
//     color: "white",
//     fontWeight: "bold",
//     fontSize: '20px',
//   },

//   publishButton: {
//     textDecoration: "none",
//     padding: '12px 25px',
//     marginRight: '200px',
//     backgroundColor: 'rgba(41, 177, 133, 1)',
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     cursor: 'pointer',
//     fontSize: '20px'
//   }
// };

export default OfferProperty;
